export const pageViewRegisterInitialState = {
  path: ''
}

export type PageViewRegisterState = typeof pageViewRegisterInitialState
